import React, { SyntheticEvent, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Auth from '../admin/Auth'
import assets from '../admin/crudFunctions/assets'

const Access = () => {
  const history: any = useHistory()
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [error, setError] = useState<boolean>(false)
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)

  useEffect(() => {
    setIsAuthenticated(Auth())
  }, [])

  if (isAuthenticated) {
    history.push({ pathname: '/tecnico/panel' })
  }

  const sendCredentials = async (
    username: string,
    password: string
  ): Promise<boolean> => {
    const endpoint: string = 'token/'
    const url: string = assets.apiUrl + endpoint
    const body: string = JSON.stringify({
      username: username,
      password: password
    })

    const headers: RequestInit = {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      headers: {
        'content-type': 'application/json'
      },
      body: body
    }
    try {
      const response: Response = await fetch(url, headers)

      if (response.status >= 200 && response.status <= 299) {
        setMessage('')
        setError(false)
        return response.json()
      } else if (response.status === 401) {
        setMessage('Usuario o contraseña incorrectos')
        setError(true)
        setUsername('')
        setPassword('')
        return false
      } else {
        setMessage('Ha ocurrido un error, intenta de nuevo')
        setError(true)
        setUsername('')
        setPassword('')

        return false
      }
    } catch (error) {
      console.log(error)
      setError(true)
      setMessage('Ha ocurrido un error, intenta de nuevo')
      return false
    }
  }

  const handleSubmit = async (e: SyntheticEvent): Promise<void> => {
    e.preventDefault()

    if (!username || !password) {
      setError(true)
      setMessage('Debes llenar ambos campos')
    } else {
      setLoading(true)
      const tokens: any = await sendCredentials(username, password)
      setLoading(false)

      if (tokens) {
        localStorage.setItem('access', tokens.access)
        localStorage.setItem('refresh', tokens.refresh)
        history.push({ pathname: '/tecnico/panel' })
      }
    }
  }

  return (
    <React.Fragment>
      <div className='container grid justify-items-center mx-auto my-auto'>
        <Link to='/'>
          <button
            type='button'
            className='bg-viper mt-7 rounded-lg h-10 w-32 text-center text-2xl text-white'>
            Inicio
          </button>
        </Link>
        <img
          src='../logo.png'
          alt='Vipernet Logo'
          className='mb-3 w-1/3 md:w-1/5 mt-5'
        />
        <h1 className='mt-8 text-4xl font-bold mb-10'>TECNICO</h1>

        {error && (
          <h2 className='text-2xl text-center w-10/12 text-red-500'>
            {message}
          </h2>
        )}

        {loading ? (
          <div className='loader animate-spin mt-5'></div>
        ) : (
          <form className='grid' onSubmit={handleSubmit}>
            <label htmlFor='username' className='text-3xl'>
              Usuario
            </label>
            <input
              type='text'
              name='username'
              id='username'
              className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-2xl mb-8'
              onChange={(e) => setUsername(e.target.value)}
            />

            <label htmlFor='password' className='text-3xl'>
              Contraseña
            </label>
            <input
              type='password'
              name='password'
              id='password'
              className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-2xl mb-8'
              onChange={(e) => setPassword(e.target.value)}
            />

            <button
              type='submit'
              className='bg-black active:bg-gray-800 rounded-full h-14 w-80 text-center text-white text-3xl'>
              Iniciar Sesión
            </button>
          </form>
        )}
      </div>
    </React.Fragment>
  )
}

export default Access
